export class MapboxApiError extends Error {
  constructor(error) {
    let message = error.message;
    if (error.response) {
      // Request made and server responded
      const { data, status } = error.response;
      if (data?.message) {
        message = `${status ?? ""} ${data.message}`;
      }
    }

    super(message);
    this.name = "MapboxApiError";
  }
}
